module.exports = __webpack_public_path__ + "img/sigConsent.2f06f5a5.png";